// Minimum darts needed to finish each score (0-180) with straight-out (single-out)
// null = impossible to finish
export const STRAIGHT_OUT_MIN_DARTS = [
    null,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    2,
    1,
    1,
    1,
    2,
    1,
    2,
    1,
    1,
    1,
    2,
    1,
    2,
    2,
    1,
    2,
    2,
    1,
    2,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    1,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    3,
    2,
    2,
    3,
    2,
    2,
    3,
    2,
    2,
    3,
    3,
    2,
    3,
    3,
    2,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    null,
    3,
    3,
    null,
    3,
    3,
    null,
    3,
    3,
    null,
    null,
    3,
    null,
    null,
    3,
    null,
    null,
    3,
]

// Minimum darts needed to finish each score (0-180) with double-out
// null = impossible to finish
export const DOUBLE_OUT_MIN_DARTS = [
    null,
    null,
    1,
    2,
    1,
    2,
    1,
    2,
    1,
    2,
    1,
    2,
    1,
    2,
    1,
    2,
    1,
    2,
    1,
    2,
    1,
    2,
    1,
    2,
    1,
    2,
    1,
    2,
    1,
    2,
    1,
    2,
    1,
    2,
    1,
    2,
    1,
    2,
    1,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    3,
    2,
    2,
    3,
    3,
    2,
    3,
    3,
    2,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    null,
    3,
    3,
    null,
    null,
    3,
    null,
    null,
    3,
    null,
    null,
    3,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
]

// Minimum darts needed to finish each score (0-180) with master-out (finish on a double or triple)
// null = impossible to finish
export const MASTER_OUT_MIN_DARTS = [
    null,
    null,
    1,
    1,
    1,
    2,
    1,
    2,
    1,
    1,
    1,
    2,
    1,
    2,
    1,
    1,
    1,
    2,
    1,
    2,
    1,
    1,
    1,
    2,
    1,
    2,
    1,
    1,
    1,
    2,
    1,
    2,
    1,
    1,
    1,
    2,
    1,
    2,
    1,
    1,
    1,
    2,
    1,
    2,
    2,
    1,
    2,
    2,
    1,
    2,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    1,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    3,
    2,
    2,
    3,
    2,
    2,
    3,
    2,
    2,
    3,
    3,
    2,
    3,
    3,
    2,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    null,
    3,
    3,
    null,
    3,
    3,
    null,
    3,
    3,
    null,
    null,
    3,
    null,
    null,
    3,
    null,
    null,
    3,
]
